/** @deprecated */
export enum ServiceType {
    Additional = 'Additional',
    Bookable = 'Bookable',
    /**  @deprecated Use Additional instead */
    Orderable = 'Orderable',
    /**  @deprecated Use Bookable instead */
    Reservable = 'Reservable',
}
